import { authenticatedRequest } from './base.service';

export interface JobTitle {
  id: string;
  name: string;
  description?: string;
  userId: string;
  organizationId: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateJobTitleData {
  name: string;
  description?: string;
  userId: string;
}

export interface UpdateJobTitleData {
  name?: string;
  description?: string;
}

const getToken = (): string => {
  const token = localStorage.getItem('finara_token');
  if (!token) throw new Error('No authentication token found');
  return token;
};

export const jobTitlesService = {
  async createJobTitle(data: CreateJobTitleData): Promise<JobTitle> {
    return authenticatedRequest<JobTitle>(
      '/api/v1/job-titles',
      {
        method: 'POST',
        body: JSON.stringify(data),
      },
      getToken()
    );
  },

  async getUserJobTitles(userId: string): Promise<JobTitle[]> {
    return authenticatedRequest<JobTitle[]>(`/api/v1/job-titles/user/${userId}`, {}, getToken());
  },

  async updateJobTitle(id: string, data: UpdateJobTitleData): Promise<JobTitle> {
    return authenticatedRequest<JobTitle>(
      `/api/v1/job-titles/${id}`,
      {
        method: 'PATCH',
        body: JSON.stringify(data),
      },
      getToken()
    );
  },

  async deleteJobTitle(id: string): Promise<void> {
    return authenticatedRequest<void>(
      `/api/v1/job-titles/${id}`,
      {
        method: 'DELETE',
      },
      getToken()
    );
  },
};
